import { render, staticRenderFns } from "./AudioArea.vue?vue&type=template&id=2b3e9a84&scoped=true"
import script from "./AudioArea.vue?vue&type=script&lang=ts"
export * from "./AudioArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e9a84",
  null
  
)

export default component.exports